import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterOutlet, Router } from '@angular/router';
import { FloatLabelModule } from 'primeng/floatlabel';
import { InputTextModule } from 'primeng/inputtext';
import { ToastModule } from 'primeng/toast';
import { LanguageService } from './shared/services/language.service';
import { DashboardLayoutComponent } from './modules/layout';
import { AuthService } from './modules/auth/services';

@Component({
  standalone: true,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  imports: [RouterOutlet, FormsModule, CommonModule, ReactiveFormsModule, FloatLabelModule, InputTextModule, ToastModule, DashboardLayoutComponent],
})
export class AppComponent {
  title = 'frontend';
  isLoggedIn = false;

  constructor(private _languageService: LanguageService, private _authService: AuthService, private router: Router) {
    // Użytkownik jest zalogowany gdy ma dane w currentUser$
    this._authService.isLoggedIn$.subscribe(isLoggedIn => {
      this.isLoggedIn = isLoggedIn;
    });
  }

  toggleDarkMode() {
      document.documentElement.classList.toggle('app-dark');
  }
}
